import React, { useEffect, useState } from "react";
import BuySellBtn from "../CommonTocComponent/Stock/BuySellBtn";
import MarginReqAvail from "../CommonTocComponent/Stock/MarginReqAvail";
import TermsAndConditions from "../CommonTocComponent/Terms&Conditions/TermsAndConditions";
import StockQuote from "../CommonTocComponent/TocHeader/StockQuote";
import TocStockHeader from "../CommonTocComponent/TocHeader/TocStockHeader";
import MarketDepth from "../CommonTocComponent/MarketDepth/MarketDepth";
import ChargesMain from "../CommonTocComponent/Charges/ChargesMain";
import UnderStandingMain from "../CommonTocComponent/UnderstandSection/UnderStandingMain";
import OrderConfirmationMain from "../CommonTocComponent/OrderConfirmation/OrderConfirmationMain";
import { commodityOrder, commodityProducts, commodityValidity, } from "./CommodityConstant";
import CommodityProductOrder from "./CommodityProductOrder";
import { COMMTOCIgnoreList, TOCBUYORSELL, } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
import DeviceContext from "../../../../utils/indentifyDevice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import di from "@frameworks/web/components/features/TOC/di/servicelocator";
import mainDi from "@di";
import { CreateTOCbuttonList, orderData, productData, understandingSectionEnum, } from "../CommonTocComponent/commonTocConstant";
import { AuthToSellJourney, setUISections, setUISectionsEquity, } from "../Equity/EqTOCFunctionality";
import { chargesHandler, checkTocState, fieldValidationManager, getProductValues, } from "../constant";
import { isEqual } from "underscore";
import { OrderbookTocStateEnum, } from "@frameworks/web/components/features/OrderBook/constant";
import ChartIQTOC from "../CommonTocComponent/ChartIQ/ChartIQTOC";
import { addCommasWithConditionalDecimal, addCommasWithoutDecimal, } from "@domains/utils/numberMethods";
import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import UnderStanding from "../CommonTocComponent/UnderstandSection/UnderStanding";
const Commodity = (props) => {
    var _a, _b, _c;
    const device = DeviceContext();
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const locationState = location.state;
    const [termCondition, setTermCondition] = React.useState(false);
    const [understanding, setUnderstanding] = React.useState(false);
    const [marketDepth, setmarketDepth] = React.useState(false);
    const [charges, setCharges] = React.useState(false);
    const [confirmOrder, setConfirmOrder] = React.useState(false);
    const [convert, setConvert] = React.useState(false);
    const [refreshMargin, setrefreshMargin] = useState(null);
    const [IsBuy, setIsBuy] = useState(() => device.isDesktop ? props === null || props === void 0 ? void 0 : props.isBuy : locationState === null || locationState === void 0 ? void 0 : locationState.isBuy);
    const [underStandingSectionKey, setUnderStandingSectionKey] = useState(null);
    const [orderConfirmationList, setOrderConfirmationList] = useState([]);
    const [chartIQ, setChartIQ] = React.useState(false);
    const [activeButton, setActiveButton] = useState({
        PRODUCT: commodityProducts[0].title,
        ORDER: commodityOrder[0].title,
        VALIDITY: commodityValidity[0].title,
    });
    const [advancedOption, setAdvancedOption] = useState(false);
    const [trailingstop, seTrailingStop] = useState(false);
    const [tradeValues, setTradeValues] = useState({
        noOfLots: "1",
        quantity: "",
        limitPrice: "",
        stopLoss: "",
        target: "",
        triggerPrice: "",
        trailingstoploss: "",
        disclosedQuantity: "",
        agreeToTermsAndCondition: false,
    });
    const [formErrors, setFormErrors] = useState({
        limitPrice: { msg: "", status: false },
        stopLoss: { msg: "", status: false },
        target: { msg: "", status: false },
        triggerPrice: { msg: "", status: false },
        disclosedQuantity: { msg: "", status: false },
    });
    const [activeState, setActiveState] = useState(IsBuy ? TOCBUYORSELL.BUY : TOCBUYORSELL.SELL);
    const [margin, setMargin] = React.useState(null);
    const [buttonList, setButtonList] = useState();
    const [orderType, setOrderType] = useState();
    const [validity, setValidity] = useState();
    const [amoOrder, setAmoOrder] = useState(null);
    const [modifySection, setModifySection] = useState({
        tocState: (locationState === null || locationState === void 0 ? void 0 : locationState.tocState) || (props === null || props === void 0 ? void 0 : props.tocState) || null,
        modifyData: (locationState === null || locationState === void 0 ? void 0 : locationState.modifyData) || (props === null || props === void 0 ? void 0 : props.modifyData) || {},
    });
    const quotesDetailsEntity = useSelector((state) => state.TOCJourney.multiQuoteReducers.multiQuote.quotesDetailsEntity, isEqual);
    const limits = useSelector((state) => { var _a; return (_a = state.TOCJourney.limits) === null || _a === void 0 ? void 0 : _a.limits; }, isEqual);
    const { data: checkMarginData, loader: checkMarginLoader, errorData: checkMarginError, } = useSelector((state) => state.TOCJourney.checkMargin, isEqual);
    const { data: amo, loader: amoLoader, errorData: amoError, } = useSelector((state) => state.TOCJourney.AMOStatus, isEqual);
    const { userID: userID } = useSelector((state) => state.accountDetailsReducer, isEqual);
    const getLimitsData = () => {
        if (userID) {
            di.tocJourney.getLimits(userID);
        }
    };
    const getChargesData = () => {
        const req = {
            userID: userID,
            reqBody: {
                action: activeState.toUpperCase(),
                prd: getProductValues(buttonList, activeButton.PRODUCT),
                price: tradeValues.limitPrice,
                qty: tradeValues.noOfLots,
                sym: quotesDetailsEntity[0].symbol,
            },
        };
        di.tocJourney.brokerChargeComm(req);
    };
    const updateMargin = () => {
        di.tocJourney.checkMargin(refreshMargin);
    };
    const getRmssSublimitsData = () => {
        if (userID)
            di.tocJourney.getRmsSublimits(userID);
    };
    const disableSell = () => {
        return ((activeButton.PRODUCT === commodityProducts[2].title &&
            !tradeValues.agreeToTermsAndCondition) ||
            !activeButton.ORDER ||
            !activeButton.PRODUCT ||
            tradeValues.quantity <= "0" ||
            Object.values(formErrors)
                .map((x) => x.status)
                .some((x) => x));
    };
    const proceedToPlaceOrder = () => {
        createFormErrorFields(true)
            .then((data) => {
            setFormErrors(data);
            if (Object.values(data)
                .map((x) => x.status)
                .some((x) => x)) {
                disableSell();
            }
            else {
                updateMargin();
                setConfirmOrder(true);
            }
        })
            .catch((err) => { });
    };
    const CreatebuttonList = async (isAmo, isBOSelected, isModify, modifyData) => {
        let ignoreList = COMMTOCIgnoreList;
        let FinalButtons = await CreateTOCbuttonList(quotesDetailsEntity ? quotesDetailsEntity[0].exchange : "MCX", ignoreList, isAmo, isModify, modifyData, isBOSelected);
        return FinalButtons;
    };
    const amoSelecterHandler = async (val, textContent) => {
        var _a, _b;
        await setAmoOrder(val);
        let isModify = (locationState === null || locationState === void 0 ? void 0 : locationState.tocState)
            ? checkTocState(locationState === null || locationState === void 0 ? void 0 : locationState.tocState, OrderbookTocStateEnum.MODIFY)
            : (props === null || props === void 0 ? void 0 : props.tocState)
                ? checkTocState(props === null || props === void 0 ? void 0 : props.tocState, OrderbookTocStateEnum.MODIFY)
                : false;
        let isBOOrder = textContent === commodityProducts[2].title;
        let buttonList = await CreatebuttonList(val, isBOOrder, isModify, modifySection.modifyData);
        await setButtonList(buttonList === null || buttonList === void 0 ? void 0 : buttonList.products);
        await setOrderType(buttonList === null || buttonList === void 0 ? void 0 : buttonList.orderType);
        await setValidity(buttonList === null || buttonList === void 0 ? void 0 : buttonList.validity);
        if (val) {
            await setActiveButton(Object.assign(Object.assign({}, activeButton), { ORDER: (_a = commodityOrder[1]) === null || _a === void 0 ? void 0 : _a.title }));
            if (activeButton.PRODUCT === commodityProducts[2].value) {
                await setActiveButton(Object.assign(Object.assign({}, activeButton), { PRODUCT: commodityProducts[0].title }));
            }
        }
        if (textContent) {
            await setActiveButton(Object.assign(Object.assign({}, activeButton), { PRODUCT: textContent, ORDER: textContent == commodityProducts[2].value
                    ? (_b = commodityOrder[1]) === null || _b === void 0 ? void 0 : _b.title
                    : activeButton.ORDER }));
        }
    };
    const createFormErrorFields = async (isSubmit) => {
        return new Promise((res, error) => {
            let getUIstatus = setUISectionsEquity(activeButton);
            let isModify = checkTocState(modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, OrderbookTocStateEnum.MODIFY);
            const validation = fieldValidationManager(tradeValues, activeState, quotesDetailsEntity[0]);
            res({
                limitPrice: !(getUIstatus === null || getUIstatus === void 0 ? void 0 : getUIstatus.disabledLimitInput)
                    ? isSubmit
                        ? validation.getLimitValidation
                        : !tradeValues.limitPrice
                            ? { msg: "", status: true }
                            : validation.getLimitValidation
                    : { msg: "", status: false },
                triggerPrice: getUIstatus.showTriggerPrice
                    ? isSubmit
                        ? validation.getTriggerValidation
                        : !tradeValues.triggerPrice
                            ? { msg: "", status: true }
                            : validation.getTriggerValidation
                    : { msg: "", status: false },
                stopLoss: getUIstatus.showStopLoss
                    ? isSubmit
                        ? validation.getStoplossValidation
                        : !tradeValues.stopLoss && !isModify
                            ? { msg: "", status: true }
                            : validation.getStoplossValidation
                    : { msg: "", status: false },
                target: getUIstatus.showTargetPrice
                    ? isSubmit
                        ? validation.getTargetValidation
                        : !tradeValues.target && !isModify
                            ? { msg: "", status: true }
                            : validation.getTargetValidation
                    : { msg: "", status: false },
                disclosedQuantity: isSubmit
                    ? validation.getDisclossValidation
                    : { msg: "", status: false },
                // trailingStopLoss:
                //   trailingstop && !tradeValues.trailingstoploss
                //     ? { msg: "", status: true }
                //     : { msg: "", status: false },
            });
        });
    };
    const updateModifiedData = React.useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return {
            quintity: ((_a = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _a === void 0 ? void 0 : _a.netQty)
                ? (_b = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _b === void 0 ? void 0 : _b.netQty
                : "",
            trailingstoploss: "",
            disclosedQuantity: +((_c = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _c === void 0 ? void 0 : _c.discloseQty) > 0
                ? (_d = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _d === void 0 ? void 0 : _d.discloseQty
                : "",
            limitPrice: ((_e = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _e === void 0 ? void 0 : _e.limitPrice)
                ? (_f = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _f === void 0 ? void 0 : _f.limitPrice
                : "",
            triggerPrice: ((_g = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _g === void 0 ? void 0 : _g.triggerPrice)
                ? (_h = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _h === void 0 ? void 0 : _h.triggerPrice
                : "",
            agreeToTermsAndCondition: true,
        };
    }, [modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData]);
    useEffect(() => {
        !checkMarginLoader &&
            !checkMarginError.isOpen &&
            setMargin(checkMarginData);
    }, [checkMarginData, checkMarginLoader, checkMarginError]);
    useEffect(() => {
        !amoLoader &&
            !amoError.isOpen &&
            !(props === null || props === void 0 ? void 0 : props.tocState) &&
            !(locationState === null || locationState === void 0 ? void 0 : locationState.tocState) &&
            amoSelecterHandler(amo === null || amo === void 0 ? void 0 : amo.status);
    }, [amo, amoLoader, amoError]);
    useEffect(() => {
        var _a, _b, _c;
        margin &&
            activeButton &&
            tradeValues &&
            setOrderConfirmationList([
                {
                    title: "Action",
                    value: activeState,
                },
                {
                    title: "Product type",
                    value: (_a = buttonList === null || buttonList === void 0 ? void 0 : buttonList.find((x) => x.title === (activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT))) === null || _a === void 0 ? void 0 : _a.value,
                },
                {
                    title: "Order type",
                    value: (_b = orderType === null || orderType === void 0 ? void 0 : orderType.find((x) => x.title === (activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER))) === null || _b === void 0 ? void 0 : _b.title,
                },
                {
                    title: "No of Lots",
                    value: `${addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.noOfLots)} 
          ${(quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0
                        ? `(Qty:${addCommasWithoutDecimal(Number((_c = quotesDetailsEntity[0]) === null || _c === void 0 ? void 0 : _c.lotSize) *
                            Number(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.noOfLots))})`
                        : ""}`,
                },
                {
                    title: "Limit price",
                    value: addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.limitPrice),
                    isHide: setUISections(activeButton, true).disabledLimitInput,
                },
                {
                    title: "Trigger price",
                    value: addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.triggerPrice),
                    isHide: !setUISections(activeButton, true).showTriggerPrice,
                },
                {
                    title: "Stop Loss",
                    value: `-${addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.stopLoss)} pts`,
                    isHide: !setUISections(activeButton, true).showStopLoss,
                },
                {
                    title: "Target",
                    value: `+${addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.target)} pts`,
                    isHide: !setUISections(activeButton, true).showTargetPrice,
                },
                // {
                //   title: "Trailing Stop Loss",
                //   value: `+${addCommasWithConditionalDecimal(
                //     tradeValues?.trailingstoploss
                //   )} pts`,
                //   isHide: !trailingstop,
                // },
            ]);
    }, [activeState, activeButton, margin, tradeValues, trailingstop]);
    const removeMarginData = () => {
        di.tocJourney.flushMarginData();
    };
    const closeTOC = () => {
        removeMarginData();
        !device.isDesktop ? navigate(-1) : props.setShowTOC(false);
    };
    useEffect(() => {
        getLimitsData();
        updateMargin();
        if (localStorage.getItem("acc_data") &&
            !(props === null || props === void 0 ? void 0 : props.tocState) &&
            !(locationState === null || locationState === void 0 ? void 0 : locationState.tocState)) {
            CreatebuttonList(amoOrder).then((list) => {
                setButtonList(list === null || list === void 0 ? void 0 : list.products);
                setOrderType(list === null || list === void 0 ? void 0 : list.orderType);
                setValidity(list === null || list === void 0 ? void 0 : list.validity);
            });
        }
    }, []);
    React.useEffect(() => {
        if (quotesDetailsEntity && (quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0) {
            setTradeValues(Object.assign(Object.assign({}, tradeValues), { limitPrice: quotesDetailsEntity[0].lastTradedPrice, quantity: quotesDetailsEntity[0].lotSize }));
        }
    }, [quotesDetailsEntity]);
    //
    // useEffect(() => {
    //   getRmssSublimitsData();
    //   updateMargin();
    //   if (!device.isDesktop && location && locationState?.Authsymbol) {
    //     AuthToSellJourney().multiquote(location, locationState?.Authsymbol);
    //   }
    //   if (localStorage.getItem("acc_data")) CreatebuttonList();
    // }, []);
    // Changes for testing
    useEffect(() => {
        if (userID) {
            getRmssSublimitsData();
            if (params === null || params === void 0 ? void 0 : params.symbol) {
                AuthToSellJourney().multiquote(location, params === null || params === void 0 ? void 0 : params.symbol);
                const payload = {
                    symbol: params === null || params === void 0 ? void 0 : params.symbol,
                };
                mainDi.common.getScripDetailData(payload);
            }
            if (localStorage.getItem("acc_data"))
                CreatebuttonList();
        }
    }, [params, userID]);
    React.useEffect(() => {
        if (activeButton && (!(props === null || props === void 0 ? void 0 : props.tocState) || !(locationState === null || locationState === void 0 ? void 0 : locationState.tocState))) {
            createFormErrorFields().then((data) => {
                setFormErrors(data);
            });
        }
    }, [activeButton, activeState, advancedOption]);
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (updateModifiedData && ((props === null || props === void 0 ? void 0 : props.tocState) || (locationState === null || locationState === void 0 ? void 0 : locationState.tocState))) {
            setTradeValues(updateModifiedData);
            // setNseBse(
            //   modifySection?.modifyData?.exchange
            //     ? modifySection?.modifyData?.exchange
            //     : nseBse
            // );
            createFormErrorFields().then((data) => {
                setFormErrors(data);
            });
            let isModify = (locationState === null || locationState === void 0 ? void 0 : locationState.tocState)
                ? checkTocState(locationState === null || locationState === void 0 ? void 0 : locationState.tocState, OrderbookTocStateEnum.MODIFY)
                : (props === null || props === void 0 ? void 0 : props.tocState)
                    ? checkTocState(props === null || props === void 0 ? void 0 : props.tocState, OrderbookTocStateEnum.MODIFY)
                    : false;
            let modifyData = (locationState === null || locationState === void 0 ? void 0 : locationState.modifyData)
                ? locationState === null || locationState === void 0 ? void 0 : locationState.modifyData
                : props === null || props === void 0 ? void 0 : props.modifyData;
            setModifySection({
                tocState: (locationState === null || locationState === void 0 ? void 0 : locationState.tocState)
                    ? locationState === null || locationState === void 0 ? void 0 : locationState.tocState
                    : props === null || props === void 0 ? void 0 : props.tocState,
                modifyData: modifyData,
            });
            setAmoOrder((_a = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _a === void 0 ? void 0 : _a.isAmo);
            let isBOOrder = (modifyData === null || modifyData === void 0 ? void 0 : modifyData.productType) == commodityProducts[2].title;
            CreatebuttonList((_b = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _b === void 0 ? void 0 : _b.isAmo, isBOOrder, isModify, modifyData).then((list) => {
                setButtonList(list === null || list === void 0 ? void 0 : list.products);
                setOrderType(list === null || list === void 0 ? void 0 : list.orderType);
                setValidity(list === null || list === void 0 ? void 0 : list.validity);
            });
            setActiveButton(Object.assign(Object.assign({}, activeButton), { PRODUCT: (_c = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _c === void 0 ? void 0 : _c.productType, ORDER: (_d = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _d === void 0 ? void 0 : _d.orderType, VALIDITY: (_e = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _e === void 0 ? void 0 : _e.validity }));
        }
    }, [updateModifiedData]);
    return (React.createElement(React.Fragment, null, confirmOrder ? (React.createElement(OrderConfirmationMain, { setConfirmOrder: setConfirmOrder, show: confirmOrder, orderConfirmationList: orderConfirmationList, exchange: quotesDetailsEntity && quotesDetailsEntity[0]
            ? (_a = quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.exchange
            : "", action: activeState, activeButton: activeButton, tradeValues: tradeValues, amoOrder: amoOrder, buttonList: buttonList })) : charges ? (React.createElement(ChargesMain, { show: charges, setShow: setCharges })) : marketDepth ? (React.createElement(MarketDepth, { setmarketDepth: setmarketDepth, show: marketDepth, isTabHide: true })) : chartIQ ? (React.createElement(ChartIQTOC, { symbol: quotesDetailsEntity ? quotesDetailsEntity[0].symbol : "", instru: quotesDetailsEntity ? quotesDetailsEntity[0].type : "", show: chartIQ, goBack: () => setChartIQ(false) })) : (React.createElement(React.Fragment, null, termCondition ? (React.createElement(TermsAndConditions, { show: termCondition, setShow: setTermCondition })) : understanding ? (React.createElement(UnderStandingMain, { show: understanding, setShow: setUnderstanding, content: React.createElement(GenericTabs, { defaultActiveKey: underStandingSectionKey, tabsArray: [
                {
                    title: "Product Type",
                    eventKey: understandingSectionEnum.PRODUCT,
                    tabContent: (React.createElement(UnderStanding, { data: productData, activeKey: activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT })),
                },
                {
                    title: "Order Type",
                    eventKey: understandingSectionEnum.ORDER,
                    tabContent: (React.createElement(UnderStanding, { data: orderData, activeKey: activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER })),
                },
            ] }) })) : (React.createElement(React.Fragment, null,
        React.createElement(TocStockHeader, { children: React.createElement(StockQuote, { textInsteadToggle: true, stockQuoteDetails: quotesDetailsEntity, setChartIQ: () => setChartIQ(true), hideHoldings: true, exchangeType: quotesDetailsEntity
                    ? (_b = quotesDetailsEntity[0]) === null || _b === void 0 ? void 0 : _b.exchange
                    : "" }) }),
        React.createElement(CommodityProductOrder, { setTermCondition: setTermCondition, setUnderstanding: setUnderstanding, setmarketDepth: setmarketDepth, multiQuoteEntity: (quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0
                ? quotesDetailsEntity[0]
                : {}, setrefreshMargin: setrefreshMargin, setUnderStandingSectionKey: setUnderStandingSectionKey, activeState: activeState, buttonList: buttonList, orderType: orderType, validity: validity, setActiveButton: setActiveButton, activeButton: activeButton, tradeValues: tradeValues, setTradeValues: setTradeValues, amoOrder: amoOrder, setAmoOrder: amoSelecterHandler, margin: margin, advancedOption: advancedOption, setAdvancedOption: setAdvancedOption, trailingstop: trailingstop, seTrailingStop: seTrailingStop, formErrors: formErrors, setFormErrors: setFormErrors }),
        React.createElement("div", { className: "bottom-contents" },
            React.createElement(MarginReqAvail, { setCharges: setCharges, getChargesData: getChargesData, updateMargin: updateMargin, margin: margin, disableCharges: chargesHandler(tradeValues), availableCash: (_c = limits === null || limits === void 0 ? void 0 : limits.lmt) === null || _c === void 0 ? void 0 : _c.lmAvl }),
            React.createElement(BuySellBtn, { refreshLabelTitle: !IsBuy ? TOCBUYORSELL.BUY : TOCBUYORSELL.SELL, buySellRefresh: true, cancelAction: closeTOC, rightButton: {
                    btnTyp: IsBuy === true ? "green-btn" : "red-btn",
                    value: IsBuy ? TOCBUYORSELL.BUY : TOCBUYORSELL.SELL,
                    className: "w-100 text-transform-uppercase",
                    onClick: () => proceedToPlaceOrder(),
                    disabled: disableSell(),
                }, isBuy: IsBuy, onCallBackFunction: () => {
                    setIsBuy(!IsBuy);
                    setActiveState(!IsBuy ? TOCBUYORSELL.BUY : TOCBUYORSELL.SELL);
                } }))))))));
};
export default Commodity;
